import axios from "axios";

export const getLiveStormEvents = async () => {
  const response = await axios.get(
    "https://api.livestorm.co/v1/events?filter[scheduling_status]=live%2Cupcoming&include=sessions",
    {
      headers: {
        accept: "application/vnd.api+json",
        Authorization: import.meta.env.VITE_LIVESTORM_API_KEY,
      },
    }
  );

  return response.data;
};
